import { render, staticRenderFns } from "./EditStatus.vue?vue&type=template&id=2b4942f6&scoped=true&"
import script from "./EditStatus.vue?vue&type=script&lang=js&"
export * from "./EditStatus.vue?vue&type=script&lang=js&"
import style0 from "./EditStatus.vue?vue&type=style&index=0&id=2b4942f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4942f6",
  null
  
)

export default component.exports